// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Models
import { useFormQuestionsData } from '@lyon/scoped-models/form/FormQuestionsData';
import { FormQuestionItemData } from '@lyon/scoped-models/form/FormQuestionItemData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { Scrollbar } from '@lyon/components/utils/Scrollbar';
import { LyonUpdateFormOutlineTabListItem } from './LyonUpdateFormOutlineTabListItem';

// ANCHOR Styles
import { BLOCK } from './styles';

export const LyonUpdateFormOutlineTabList = constant(() => {
  const questions = useFormQuestionsData();

  if (!questions) {
    return <Loader />;
  }

  if (questions.length === 0) {
    return (
      <Block display="flex" justifyContent="center">
        <LabelLarge marginTop="32px">
          There are no added questions yet.
        </LabelLarge>
      </Block>
    );
  }

  return (
    <Scrollbar>
      <Block overrides={BLOCK}>
        {
          questions.map((question) => (
            <FormQuestionItemData.Provider key={question.id} data={question}>
              <LyonUpdateFormOutlineTabListItem />
            </FormQuestionItemData.Provider>
          ))
        }
      </Block>
    </Scrollbar>
  );
});
